import { render, staticRenderFns } from "./CopyIntegrations.vue?vue&type=template&id=59f3f563"
import script from "./CopyIntegrations.vue?vue&type=script&lang=js"
export * from "./CopyIntegrations.vue?vue&type=script&lang=js"
import style0 from "./CopyIntegrations.vue?vue&type=style&index=0&id=59f3f563&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports